import { CloseIcon, SearchIcon } from 'assets/icons'
import React, {
  HTMLInputTypeAttribute,
  ChangeEvent,
  Dispatch,
  SetStateAction
} from 'react'

interface SearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  inputType?: HTMLInputTypeAttribute
  className?: string
  setValue?: Dispatch<SetStateAction<string>>
  handler?: (e: ChangeEvent<HTMLInputElement>) => void
  handleCleanInput?: () => void
}

const SearchInput = ({
  inputType = 'text',
  className = '',
  disabled = false,
  maxLength = 100,
  value = '',
  setValue,
  handleCleanInput,
  handler = () => null,
  ...props
}: SearchInputProps) => (
  <div className='relative'>
    <SearchIcon
      className={`left-4 top-2 absolute ${disabled && 'stroke-gray-600'}`}
    />
    <button
      onClick={() => handleCleanInput()}
      className={`right-4 top-2 absolute ${value == '' && 'hidden'}`}
    >
      <span className='sr-only'>Borrar</span>
      <CloseIcon />
    </button>
    <input
      className={`text-xs appearance-none flex items-center bg-white text-black font-medium overflow-hidden w-full border border-gray-500 rounded-[1.25rem] focus:ring-purple-900/10 focus:ring-4 h-8 !focus:ring-offset-0 placeholder:text-black placeholder:font-medium focus:border-purple-900 px-10 disabled:bg-gray-300 disabled:border-none disabled:placeholder:text-gray-600 ${className}`}
      onChange={(e) => handler(e)}
      value={value}
      maxLength={maxLength}
      disabled={disabled}
      type={inputType}
      {...props}
    />
  </div>
)

export default SearchInput
